import React from 'react';
import { Button, Stack } from '@/theme/index';

interface ScheduleServiceButtonProps {
  type: string;
  vin: string | null | undefined;
  zipCode: string | null | undefined;
}

export const ScheduleServiceButton = ({
  type,
  vin,
  zipCode,
}: ScheduleServiceButtonProps) => {
  const baseServiceLink =
    'https://app.openbay.com/service-request/services/service?services[]=';

  const serviceTypeIds = {
    oil: 15657,
    brake: 555,
    tire: null,
  };

  const typeId = serviceTypeIds[type as keyof typeof serviceTypeIds];
  const link = `${baseServiceLink}${typeId}&zipcode=${zipCode}&vin=${vin}`;

  const handleClick = () => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <Stack flexDirection="row" justifyContent="center">
      <Button
        onClick={handleClick}
        variant="contained"
        color="success"
        sx={{
          width: 'fit-content',
          alignSelf: 'center',
        }}
      >
        Schedule service
      </Button>
    </Stack>
  );
};
